import http from "infra/http";
import { useMutation } from "react-query";

function useUpdateFormaPagamento(id: string, tenantId: string) {
  return useMutation(
    [`/v1/forma-pagamento/:id`],
    async (body: { taxaExtra: number }) => {
      return http.put(`/v1/forma-pagamento/${id}`, body, {
        headers: {
          tenant: tenantId,
        },
      });
    }
  );
}

export default useUpdateFormaPagamento;
